import React, { useState, useEffect } from 'react';
import { HiBanknotes, HiUsers, HiUserPlus, HiChartBar } from "react-icons/hi2";
import { motion } from 'framer-motion';
import CardDataStats from '../../../components/CardDataStats';
import Cookies from 'js-cookie';
import ChartOne from '../../../components/ChartOne';
import ChartThree from '../../../components/ChartThree';
import { Link } from 'react-router-dom';
import TableOne from '../../../components/TableOne';

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const adminToken = Cookies.get('adminKey');
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URI}admin/dashboardData`, {
          method: 'GET',
          headers: {
            "Admin-Token": adminToken
          }
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setDashboardData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#406580]"></div>
      </div>
    );
  }

  return (
    <section className="dashboard w-full max-w-[1600px] mx-auto px-4 py-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Dashboard Overview</h1>
        <p className="text-gray-600">Benvenuto nel pannello di amministrazione</p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4"
      >
        <CardDataStats 
          title="Visitatori Giornalieri" 
          total={dashboardData.dailyVisitors} 
          rate="0.43%" 
          levelUp
          className="bg-gradient-to-br from-blue-50 to-blue-100 hover:shadow-lg transition-all duration-300"
        >
          <div className="flex h-11.5 w-11.5 items-center justify-center rounded-full bg-blue-500/20">
            <HiBanknotes className="text-2xl text-blue-500" />
          </div>
        </CardDataStats>

        <CardDataStats 
          title="Vendite Giornaliere" 
          total={dashboardData.dailySales} 
          rate="4.35%" 
          levelUp
          className="bg-gradient-to-br from-green-50 to-green-100 hover:shadow-lg transition-all duration-300"
        >
          <div className="flex h-11.5 w-11.5 items-center justify-center rounded-full bg-green-500/20">
            <HiUsers className="text-2xl text-green-500" />
          </div>
        </CardDataStats>

        <CardDataStats 
          title="Utenti Giornalieri" 
          total={dashboardData.totalProducts || 0} 
          rate="2.59%" 
          levelUp
          className="bg-gradient-to-br from-yellow-50 to-yellow-100 hover:shadow-lg transition-all duration-300"
        >
          <div className="flex h-11.5 w-11.5 items-center justify-center rounded-full bg-yellow-500/20">
            <HiUserPlus className="text-2xl text-yellow-500" />
          </div>
        </CardDataStats>

        <CardDataStats 
          title="Ordini Giornalieri" 
          total={dashboardData.dailyUsers} 
          rate="0.95%" 
          levelDown
          className="bg-gradient-to-br from-red-50 to-red-100 hover:shadow-lg transition-all duration-300"
        >
          <div className="flex h-11.5 w-11.5 items-center justify-center rounded-full bg-red-500/20">
            <HiChartBar className="text-2xl text-red-500" />
          </div>
        </CardDataStats>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 mt-8 xl:grid-cols-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="xl:col-span-8"
        >
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between mb-6">
              <Link className="text-xl font-semibold text-gray-800" to={"https://analytics.google.com/analytics/web/?hl=it#/p466982683/reports/intelligenthome?params=_u..nav%3Dmaui"}>
                Statistiche Visualizzazioni - marroccoart.com
              </Link>
            </div>
            <ChartOne googlePropertyId={466982683} />
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="xl:col-span-4"
        >
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="text-xl font-semibold text-gray-800 mb-6">Distribuzione Devices - ferromarrocco.com</h3>
            <ChartThree googlePropertyId={466982683} />
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="xl:col-span-8"
        >
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between mb-6">
              <Link className="text-xl font-semibold text-gray-800" to={"https://analytics.google.com/analytics/web/?hl=it#/p453529153/reports/intelligenthome?params=_u..nav%3Dmaui"}>
                Statistiche Visualizzazioni - ferromarrocco.com
              </Link>
            </div>
            <ChartOne googlePropertyId={453529153} />
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="xl:col-span-4"
        >
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="text-xl font-semibold text-gray-800 mb-6">Distribuzione Devices - ferromarrocco.com</h3>
            <ChartThree googlePropertyId={453529153} />
          </div>
        </motion.div>

        {/* <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="xl:col-span-12"
        >
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="text-xl font-semibold text-gray-800 mb-6">Ultimi Ordini</h3>
            <TableOne />
          </div>
        </motion.div> */}
      </div>
    </section>
  );
}